import React, {useState, useEffect} from 'react';
import { useLocation } from 'react-router-dom';
import styles from './Showcase.module.css';
import NavigationMenu from './NavigationMenu';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import BlurredTextBox from './BlurredTextBox';
import { BeatLoader } from 'react-spinners';
import DropdownComponent from './DropdownComponent';

function GoLiveBot() {
  const navigate = useNavigate();
  const [isTikTokLoggedIn, setisTikTokLoggedIn] = useState(false); // State for tracking login status
  const [isLoading, setIsLoading] = useState(true); // State for tracking loading status
  const [imageUrl, setImageUrl] = useState('');
  const [isCollapsed, setIsCollapsed] = useState(window.innerWidth < 768); // State for tracking collapsed status

  const location = useLocation();
  const user = location.state?.user;
  const csrfState = Math.random().toString(36).substring(2);
  const [authWindow, setAuthWindow] = useState(null);
  let slideIndex = 0;
  var videoURLS = [];
  var LONG_ACCESSTOKEN = "";
  var REFRESH_TOKEN = "";
  var TiktokVideoData = [];
  var intervals = [];
  var sideNavSize = 300;
  useEffect(() => {
    function handleResize() {
      setIsCollapsed(window.innerWidth < (768 + sideNavSize));
    }

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // var isTikTokLoggedIn = false;
  const OpenAuth = () => {

      OpenAuthWindow();
  };

  function OpenAuthWindow(){
    let loading = true;

    const loginUrl = 'https://www.tiktok.com/v2/auth/authorize/?client_key=awlpq7ud2ia3i66v&scope=user.info.basic,video.list,video.upload,video.publish&response_type=code&redirect_uri=https%3A%2F%2Fjoshmcgiff.github.io%2FtiktokRedirectStreamably%2F&state=' + csrfState;
    window.location.href = loginUrl

  };

  async function GetTiktokVideoData(){
    const getTiktoksUrl = 'https://super-stream.co/api/getTiktoks/' + LONG_ACCESSTOKEN + '?userId=' + localStorage.getItem('_id');    
    await fetch(getTiktoksUrl, {
                method: 'GET',
                redirect: 'follow',
                headers: {
                    'Content-Type': 'application/json',
                  },
                }
        )
    .then(response => response.json())
    .then(data => {
        let listOfEmbedLinks = '';
        let intervalArray = [];
        data.data.videos.forEach(function(video) {
            // do something with each video
            // for example, log the video's title
            console.log(video.embed_link);
            intervalArray.push(video.duration);
            videoURLS.push(video.cover_image_url);
            listOfEmbedLinks = listOfEmbedLinks + video.embed_link +  "$&?!-_";
            
          });
          TiktokVideoData = listOfEmbedLinks;
          intervals = intervalArray;
          ImageCarouselTimer();
        // setIsLoading(false);
        // setIsLoggedIn(true);
       })
    .catch(error => console.log(error));
    console.log(TiktokVideoData);
    console.log(intervals);
   
  }
  
  console.log(window.location.search);
  useEffect(() => {
    if(window.location.search.length > 1){
      console.log(window.location.search);
      const url = window.location.search;
      const ampersandIndex = url.indexOf('&', url.indexOf('?') + 1);
      const queryString = url.substring(url.indexOf('?') + 1, ampersandIndex);
      console.log(queryString); 
      GetAccessTokenTikTok(queryString);
      setisTikTokLoggedIn(true);
      navigate("/showcase");
      console.log("i have not navigated yet");
      // setIsLoggedIn(true);
    }else {
      axios.get('https://super-stream.co/api/getTiktokInfo/' + localStorage.getItem("_id")).then(async (response) => {
        console.log("found info for user", response);
        // need to pull token from response and use it to init the ui for the logged in user
        LONG_ACCESSTOKEN = response.data.data.tiktokToken;
        if(LONG_ACCESSTOKEN != null && LONG_ACCESSTOKEN != ""){
          await GetTiktokVideoData();
          setisTikTokLoggedIn(true);
          ImageCarouselTimer();
        }else{
          setisTikTokLoggedIn(false);
        }
      });
    }
  }, [navigate]);
  


  async function GetAccessTokenTikTok(tiktokToken){
    console.log('this is the: ' + decodeURI(tiktokToken));
    const decodedToken = decodeURI(tiktokToken);
    const firstUrl = "https://super-stream.co/api/getTiktokAccessToken/" + decodedToken;
    let responseLong = await fetch(firstUrl, {
      method: 'GET',
      redirect: 'follow',
      headers: {
          'Content-Type': 'application/x-www-form-urlencoded',

      },
    });

  let dataLong = await responseLong.json();
  console.log(dataLong);
  LONG_ACCESSTOKEN = dataLong.access_token;
  REFRESH_TOKEN = dataLong.refresh_token;
  console.log(LONG_ACCESSTOKEN);

  let postToken = await fetch('https://super-stream.co/api/tiktok', {
    method: 'POST',
    redirect: 'follow',
    headers: {
        'Content-Type': 'application/json',
    },
    body: JSON.stringify({tiktokToken: LONG_ACCESSTOKEN, tiktokRefreshToken: REFRESH_TOKEN, id: localStorage.getItem('_id')})
  });

  let dataPost = await postToken.json();
  console.log("hello");
  console.log(dataPost);

  await GetTiktokVideoData();

  }
  var ImageCarouselTimerObject = null;
  function ImageCarouselTimer(){
    if(videoURLS.length == 0){
      return;
    }
    if(slideIndex < videoURLS.length){
      if(document.getElementById("imageCarousel") == null){
        ImageCarouselTimerObject = setTimeout(ImageCarouselTimer, 1000);
        slideIndex = 0;
      }else{
        document.getElementById('imageCarousel').style.display = '';
        document.getElementById("imageCarousel").src = videoURLS[slideIndex];
        slideIndex++;
        ImageCarouselTimerObject = setTimeout(ImageCarouselTimer, 1000);
        setIsLoading(false);
      }
    }else{
      slideIndex = 0;
      ImageCarouselTimer();
    }
  }

  async function TiktokLogOut(){
    // remove tiktoktoken and tiktokrefreshtoken from db
    LONG_ACCESSTOKEN = "";
    REFRESH_TOKEN = "";
    let postToken = await fetch('https://super-stream.co/api/tiktok', {
      method: 'POST',
      redirect: 'follow',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({tiktokToken: LONG_ACCESSTOKEN, tiktokRefreshToken: REFRESH_TOKEN, id: localStorage.getItem('_id')})
    });
    setisTikTokLoggedIn(false);
  }
    return (
      <div className={`container-fluid`}>
          <div className="row">
              <div className="col">
                    <div className="row">
                      <div className={`col-2 nonScrollable ${isCollapsed ? `hideSidebar` : `showSidebar`}`}  style={{paddingRight: 0, paddingLeft: 0, width: sideNavSize + 'px'}}>
                            <NavigationMenu />
                      </div>
                      <div className={` col scrollable ${isCollapsed ? 'col-12' : ''}`} style={{ order: 1 }}>
                        <div className="scrollableContent">
                            <div className="App content-centered">
                                <div className='row'> {/* this is to make a grid system within the app window */}
                                  <div className={styles.box}>
                                    <img className={`${styles.logoBanner} img-fluid object-fit-scale`} src="socialframebanner.png"></img>
                                    {/* <h1 style={{color: 'black'}}>Showcase</h1> */}
                                  </div>
                                </div>

                                <div className='row'> {/* this is to make a grid system within the app window */}
                                    <div className={styles.box}>
                                      {isTikTokLoggedIn ? (
                                        <button id="SignOutButton" type="button" className={styles.button} onClick={TiktokLogOut}>Remove tiktok account</button>
                                      ) : (
                                        <button onClick={OpenAuth} type="button" className={styles.button} id="ConnectInstagramButton"><img className={styles.icon} src="instaicon.svg"></img>Connect tiktok account</button>
                                      )}
                                    </div>
                                </div>
                                <div className={styles.contained}>
                                    <div className={`row `}> {/* this is to make a grid system within the app window */}
                                        <div className='col-12 col-md-12 col-sm-12  '>
                                          <div className={`row `}>
                                              <div className={`${styles.box} `}>
                                                  <h2>Choose a video to upload when you go live:</h2>
                                              </div>
                                          </div>
                                          <div className={`row `}>
                                              <div className={`${styles.box} `}>
                                                  <button type="button" className={styles.button} >Upload video</button>
                                              </div>
                                          </div>
                                          <div className={`row `}>
                                          <video width="360" height="720" controls>
                                            <source src="testvideo.mp4" type="video/mp4" />
                                            </video>
                                          </div>
                                        </div>
                                    </div>

                                    
                               </div>

                               <div className={styles.contained}>
                                        <div className={`row `}>
                                            <div className={styles.box}>
                                                <h2 className={styles.headings} style={{ fontFamily: 'Roboto' }}>Title: </h2>
                                            </div>
                                        </div>
                                        <div className={`row `}>
                                            <div className={styles.box}>
                                                <input
                                                                        type="text"
                                                                        placeholder="Insert title here!"
                                                                    />
                                            </div>
                                        </div>
                                      </div>
                                </div>

                                <div className={styles.contained}>
                                      <div className={`row `}>
                                        <div className={styles.box}>
                                          <h2 className={styles.headings} style={{ fontFamily: 'Roboto' }}>Who can watch this video: </h2>
                                        </div>
                                      </div>
                                      <div className={`row `}>
                                      <div className={styles.box}>
                                          <DropdownComponent />
                                        </div>
                                    </div>
                                </div>

                                <div className={styles.contained}>
                                        <div className={`row `}>
                                            <div className={styles.box}>
                                                <h2 className={styles.headings} style={{ fontFamily: 'Roboto' }}>Allow viewers to: </h2>
                                            </div>
                                        </div>
                                        <div className={`row `}>
                                                <div className={styles.box}>
                                                    <label>
                                                        <input
                                                        type="checkbox"
                                                        />
                                                        Comment
                                                    </label>
                                                    <label>
                                                        <input
                                                        type="checkbox"
                                                        />
                                                        Duet
                                                    </label>
                                                    <label>
                                                        <input
                                                        type="checkbox"
                                                        />
                                                        Stitch
                                                    </label>
                                                </div>
                                        </div>
                                    </div>
                                    <div className={styles.contained}>
                                      <div className={`row `}>
                                        <div className={styles.box}>
                                        <button type="button" className={styles.button} >Upload video when live</button>
                                        </div>
                                      </div>
                                </div>
                                </div>

                                    {/* <div className={styles.contained}>
                                      <div className={`row `}>
                                        <div className={styles.box}>
                                          <h2 className={styles.headings} style={{ fontFamily: 'Roboto' }}>Follow us on Twitter: @superstreamco</h2>
                                        </div>
                                      </div>
                                    </div> */}
                            </div>
            
                          </div>
                        </div>
                    </div>
                </div>
           
    );
  }
  
  export default GoLiveBot;